import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getFetchStatus, getSearchAiSummaryText } from "../../../../store/searchAiSummary/selectors.js";
import GenAiSearchSummary from "../../GenAiSearchSummary/index.js";
import useAiSummaryController from "./useAiSummary.controller.js";
import styles from "./AiSummary.desktop.module.css";
import flights_funnel_sr_gen_ai_summary_open_desktop_all_languages from "../../../../utils/experiments/funnel/flights_funnel_sr_gen_ai_summary_open_desktop_all_languages.js";
import { getSearchResultsHidePrice, getSearchResultsVisibleIndexes } from "../../../../store/searchResults/selectors.js";
const AiSummaryDesktop = () => {
    const fetchStatus = useSelector(getFetchStatus);
    const summaryText = useSelector(getSearchAiSummaryText) || "";
    const isVariant = !!flights_funnel_sr_gen_ai_summary_open_desktop_all_languages.getVariant();
    const [shouldRender, setShouldRender] = useState(!isVariant);
    useEffect(() => {
        if (!isVariant)
            return;
        const timeout = setTimeout(() => setShouldRender(true), 100);
        return () => clearTimeout(timeout);
    }, [isVariant]);
    useEffect(() => {
        if (fetchStatus === "success") {
            if (summaryText !== "") {
                flights_funnel_sr_gen_ai_summary_open_desktop_all_languages.goals.success();
            }
            else {
                flights_funnel_sr_gen_ai_summary_open_desktop_all_languages.goals.error();
            }
        }
        else if (fetchStatus === "failed") {
            flights_funnel_sr_gen_ai_summary_open_desktop_all_languages.goals.error();
        }
    }, [fetchStatus, summaryText]);
    const hidePriceForStaggeredSearch = useSelector(getSearchResultsHidePrice);
    const searchResultsVisibleIndexes = useSelector(getSearchResultsVisibleIndexes);
    if (!shouldRender) {
        return null;
    }
    return (React.createElement("div", { role: "status", "aria-live": "polite", "aria-busy": fetchStatus === "loading" },
        React.createElement(ControllerCaller, null),
        React.createElement(GenAiSearchSummary, { variant: flights_funnel_sr_gen_ai_summary_open_desktop_all_languages.getVariant() ? "collapsed_text" : "card", summaryText: summaryText, className: styles.root, isLoading: !!searchResultsVisibleIndexes || hidePriceForStaggeredSearch || fetchStatus === "loading", isError: fetchStatus === "failed" || summaryText === "", onCtaClick: () => {
                flights_funnel_sr_gen_ai_summary_open_desktop_all_languages.goals.ctaClick();
            } })));
};
const ControllerCaller = () => {
    useAiSummaryController(flights_funnel_sr_gen_ai_summary_open_desktop_all_languages.getVariant() ? "v3" : "v2");
    return null;
};
export default AiSummaryDesktop;
